var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-docs-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-docs-modal",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "wkb-docs-modal-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "wkb-docs-close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(" × ")]
              ),
              _vm._m(0),
              _vm._m(1),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "wkb-docs-head" }, [
      _c("h2", { attrs: { id: "wkb-docs-modal-title" } }, [
        _vm._v("REVEAL KG Canvas Documentation"),
      ]),
      _c("p", [
        _vm._v(
          " A short guide to the canvas: what each part is for, when to use it, and how it fits into a typical session. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wkb-docs-body" }, [
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Canvas model")]),
        _c("p", { staticClass: "wkb-docs-lead" }, [
          _vm._v(
            " REVEAL KG Canvas is a browser-based graph canvas where you work on one graph over time—adding structure, interpreting it, and saving checkpoints as you go. "
          ),
        ]),
        _c("p", [
          _vm._v(
            " Exploration stays open-ended: you are not forced through a fixed pipeline. Use the canvas toolbar and element menus to grow or narrow the graph, open the Inspector when you need provenance, run Analyze when you want interpretation, and save when the graph reaches a state worth returning to. "
          ),
        ]),
      ]),
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Starting a graph")]),
        _c("p", { staticClass: "wkb-docs-lead" }, [
          _vm._v(" See "),
          _c("strong", [_vm._v("Help → Learn Canvas")]),
          _vm._v(
            " for how to search and select starting entities, optional neighboring nodes, and load or import saved graphs. "
          ),
        ]),
      ]),
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Top menus")]),
        _c("ul", { staticClass: "wkb-docs-feature-list" }, [
          _c("li", [
            _c("strong", [_vm._v("Analyze")]),
            _c("p", [
              _vm._v(
                " Use Analyze once the graph is in a useful shape and you want interpretation rather than more structure. "
              ),
              _c("em", [_vm._v("Explain graph")]),
              _vm._v(" summarizes patterns with an LLM; "),
              _c("em", [_vm._v("Build hypotheses")]),
              _vm._v(
                " ranks gene → mechanism → trait pathways among your selected nodes; "
              ),
              _c("em", [_vm._v("Find related datasets")]),
              _vm._v(
                " searches CFDE gene sets linked to selected genes. Each run can be reopened from numbered bubbles on the canvas while you keep working. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Manage")]),
            _c("p", [
              _vm._v(
                " Use Manage when you want a checkpoint or a portable copy. "
              ),
              _c("em", [_vm._v("New graph")]),
              _vm._v(" starts fresh. "),
              _c("em", [_vm._v("Save graph to library")]),
              _vm._v(
                " stores layout, links, filters, selected nodes, and analysis text in this browser only. "
              ),
              _c("em", [_vm._v("Export graph")]),
              _vm._v(
                " writes a JSON workflow file with inspector caches and expansion history for "
              ),
              _c("em", [_vm._v("Import graph")]),
              _vm._v(" later. "),
              _c("em", [_vm._v("Download graph snapshot")]),
              _vm._v(
                " writes a self-contained HTML file (graph image, tables, explanations, hypotheses, datasets, and cached inspector evidence) for reading or sharing outside the canvas—it cannot be reloaded into the workspace. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("My library")]),
            _c("p", [
              _vm._v(
                " My library is where browser-saved graphs live when you are not building from scratch. Open on canvas to continue a prior session, duplicate it for a variant, remove what you no longer need, or move collections between machines with "
              ),
              _c("em", [_vm._v("Back up library")]),
              _vm._v(" and "),
              _c("em", [_vm._v("Restore library backup")]),
              _vm._v(
                ". Library saves and backups store layout and session metadata only—not inspector caches, expansion history, or candidate caches. Use "
              ),
              _c("em", [_vm._v("Export graph")]),
              _vm._v(" when you need a full workflow file. "),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Help")]),
            _c("p", [
              _c("em", [_vm._v("Learn Canvas")]),
              _vm._v(" opens a short getting-started guide. "),
              _c("em", [_vm._v("Documentation")]),
              _vm._v(" opens this full guide from the top bar at any time. "),
            ]),
          ]),
        ]),
      ]),
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Canvas toolbar")]),
        _c("p", { staticClass: "wkb-docs-lead" }, [
          _vm._v(
            " Controls on the right side of the graph legend row act on the current session. "
          ),
        ]),
        _c("ul", { staticClass: "wkb-docs-feature-list" }, [
          _c("li", [
            _c("strong", [_vm._v("Expand KG (+)")]),
            _c("p", [
              _vm._v(" Opens the expand panel from your "),
              _c("em", [_vm._v("selected nodes")]),
              _vm._v(" (blue fill). Use "),
              _c("em", [_vm._v("Discover")]),
              _vm._v(
                " to fetch ranked neighbors with optional intent or novelty filters, or "
              ),
              _c("em", [_vm._v("Add nodes")]),
              _vm._v(
                " to search for a specific entity. From a node’s pointer menu, "
              ),
              _c("em", [_vm._v("Expand graph from node")]),
              _vm._v(" opens the same panel scoped to that node only; "),
              _c("em", [_vm._v("Expand graph from edge")]),
              _vm._v(
                " seeds from both endpoints. While expansion runs, a progress overlay shows neighbor classification batches and stops early once enough neighbors pass your count limit. Use the "
              ),
              _c("em", [_vm._v("History")]),
              _vm._v(" tab to review past expansion runs (restored on "),
              _c("em", [_vm._v("Import graph")]),
              _vm._v(", not My library). "),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Visibility filters (funnel)")]),
            _c("p", [
              _vm._v(
                " Opens the visibility filter panel. A numbered badge on the icon shows how many saved filters are currently enabled. See the Visibility filters section below. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Canvas assistant (AI)")]),
            _c("p", [
              _vm._v(" Opens the canvas assistant panel. See the "),
              _c("em", [_vm._v("Canvas assistant")]),
              _vm._v(
                " section below for planning and running graph actions in plain language. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Zoom")]),
            _c("p", [
              _vm._v(" Drag the slider to zoom the tree layout in or out. "),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Graph data (table)")]),
            _c("p", [
              _vm._v(
                " Opens a tabbed table of retrieved nodes from build and expansion— including candidates not yet on the canvas. Add or remove nodes from the graph directly from this table. See Graph data table below. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("View options (eye)")]),
            _c("p", [
              _vm._v(" Toggle "),
              _c("em", [_vm._v("Hide contextual edges")]),
              _vm._v(" and "),
              _c("em", [_vm._v("Hide jumping edges")]),
              _vm._v(
                ". These only affect display; they do not remove links from the saved graph. "
              ),
            ]),
          ]),
        ]),
      ]),
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Canvas assistant")]),
        _c("p", { staticClass: "wkb-docs-lead" }, [
          _vm._v(
            " The canvas assistant turns plain-language requests into a short plan of graph actions you can review and run. Open it from the toolbar AI icon after you have built a graph. "
          ),
        ]),
        _c("ul", { staticClass: "wkb-docs-feature-list" }, [
          _c("li", [
            _c("strong", [_vm._v("Request tab")]),
            _c("p", [
              _vm._v(" Type what you want to do—for example "),
              _c("em", [_vm._v("Explain selected nodes")]),
              _vm._v(", "),
              _c("em", [
                _vm._v("Select top 5 genes connected to Type 2 diabetes"),
              ]),
              _vm._v(", or "),
              _c("em", [
                _vm._v(
                  "Filter genes related to insulin resistance, then expand from selected nodes"
                ),
              ]),
              _vm._v(". Click "),
              _c("em", [_vm._v("Plan")]),
              _vm._v(
                " to generate a numbered step list. Each step shows a label and status; click "
              ),
              _c("em", [_vm._v("Run")]),
              _vm._v(" on one step or "),
              _c("em", [_vm._v("Execute all")]),
              _vm._v(
                " to run the whole plan. While steps run, progress overlays appear for expansion, filtering, and analysis actions; the graph is not interactive during execution. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Actions tab")]),
            _c("p", [
              _vm._v(
                " Browse grouped examples of what you can ask for—graph changes, analysis, view toggles, and manage actions. Click "
              ),
              _c("em", [_vm._v("Try")]),
              _vm._v(
                " on an example to copy it into the Request tab and plan from there. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Node autocomplete")]),
            _c("p", [
              _vm._v(
                " While typing in the request box, matching node labels from the current graph appear in a dropdown. Use arrow keys and Enter or Tab to insert a label into your request. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Clarify vs execute")]),
            _c("p", [
              _vm._v(
                " If the assistant cannot map your request safely—for example a named gene is not on the graph, or “top genes” is ambiguous—it returns a clarification message instead of a plan. Edit your request and plan again. Failed steps restore your original text to the input box. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("What the assistant can do")]),
            _c("p", [
              _vm._v(
                " Expand the graph, build or toggle visibility filters, mark selected nodes, explain the graph, build hypotheses, find related datasets, open or close the data table, show or hide jumping or contextual edges, inspect a node or edge, and open save/export/import/snapshot flows. Explain and filter steps require interactive LLM classification when those options are used; if LLM is unavailable, planning may still succeed but those steps will not run. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("After analysis steps")]),
            _c("p", [
              _vm._v(
                " When a plan includes Explain graph, Build hypotheses, or Find related datasets, the assistant opens the same modals and analysis bubbles as the Analyze menu after the step completes. "
              ),
            ]),
          ]),
        ]),
      ]),
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Visibility filters")]),
        _c("p", { staticClass: "wkb-docs-lead" }, [
          _vm._v(
            " Visibility filters annotate nodes on the graph and control what stays visible— without deleting nodes from the session until you choose to remove them. "
          ),
        ]),
        _c("ul", { staticClass: "wkb-docs-feature-list" }, [
          _c("li", [
            _c("strong", [_vm._v("Build a filter")]),
            _c("p", [
              _vm._v(" Open the funnel icon and switch to "),
              _c("em", [_vm._v("Create filters")]),
              _vm._v(". Choose a filter type from the dropdown— "),
              _c("em", [_vm._v("Intent")]),
              _vm._v(", "),
              _c("em", [_vm._v("Known / Novel")]),
              _vm._v(", or "),
              _c("em", [_vm._v("Expression")]),
              _vm._v("— configure that type, then click "),
              _c("em", [_vm._v("Build filter")]),
              _vm._v(
                ". Intent filters can optionally use semantic similarity instead of LLM relevance. You can build multiple filters over a session; each becomes a saved layer. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Toggle filters on or off")]),
            _c("p", [
              _vm._v(" On the "),
              _c("em", [_vm._v("Filters")]),
              _vm._v(
                " tab, each saved filter appears as a numbered bubble. Click a bubble to enable or disable it without rebuilding. All enabled filters apply together (a node must pass every enabled layer to stay visible). "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("All nodes are filtered equally")]),
            _c("p", [
              _vm._v(
                " Starting nodes, manually added nodes, and nodes returned from build or expansion are treated the same. If a starting node does not pass an enabled filter, it is hidden like any other node. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Remove invisible nodes")]),
            _c("p", [
              _vm._v(
                " When filters hide nodes, the panel shows how many are invisible and offers to remove them permanently from the graph. This is distinct from toggling a filter off, which only restores visibility. "
              ),
            ]),
          ]),
        ]),
      ]),
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Graph data table")]),
        _c("p", [
          _vm._v(
            " The graph data table lists nodes REVEAL retrieved during build and expansion, grouped by type (genes, gene sets, mechanisms, traits). Rows highlighted in blue are selected nodes. Use "
          ),
          _c("em", [_vm._v("Add to graph")]),
          _vm._v(" to place a retrieved node on the canvas, or "),
          _c("em", [_vm._v("Remove")]),
          _vm._v(
            " to drop one that is already there. Download the current tab as CSV when you need a spreadsheet copy. "
          ),
        ]),
      ]),
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Node and edge menus")]),
        _c("p", { staticClass: "wkb-docs-lead" }, [
          _vm._v(
            " Click a node or edge on the canvas to open a short action menu. Click the same element again to dismiss it. "
          ),
        ]),
        _c("ul", { staticClass: "wkb-docs-feature-list" }, [
          _c("li", [
            _c("strong", [_vm._v("Node menu")]),
            _c("p", [
              _c("em", [_vm._v("Inspect node")]),
              _vm._v(" selects the node and opens the Inspector. "),
              _c("em", [_vm._v("Mark as selected node")]),
              _vm._v(" / "),
              _c("em", [_vm._v("Remove from selected nodes")]),
              _vm._v(" updates your focus set (blue fill). "),
              _c("em", [_vm._v("Expand graph from node")]),
              _vm._v(" opens the expand panel scoped to that node only. "),
              _c("em", [_vm._v("Remove node")]),
              _vm._v(
                " deletes the node from the graph; unmark a non-starting selected node before removing it. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Edge menu")]),
            _c("p", [
              _c("em", [_vm._v("Inspect edge")]),
              _vm._v(" opens edge provenance in the Inspector. "),
              _c("em", [_vm._v("Expand graph from edge")]),
              _vm._v(
                " opens the expand panel using both endpoints of the link as expansion seeds. "
              ),
            ]),
          ]),
        ]),
      ]),
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Tree view: nodes and edges")]),
        _c("p", { staticClass: "wkb-docs-lead" }, [
          _vm._v(
            " The canvas uses a fixed four-row layout (genes, gene sets, mechanisms, traits). Symbols in the toolbar legend match what you see on the graph. "
          ),
        ]),
        _c("ul", { staticClass: "wkb-docs-feature-list" }, [
          _c("li", [
            _c("strong", [_vm._v("Selected node")]),
            _c("p", [
              _vm._v(
                " Blue circles or blue diamonds are nodes you marked as important for this session. New graphs start with your initial picks as selected nodes. Use "
              ),
              _c("em", [_vm._v("Mark as selected node")]),
              _vm._v(
                " on the node menu to add or remove them. Selected nodes drive connection ranking in the Inspector and are saved with the graph. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Starting node")]),
            _c("p", [
              _vm._v(
                " Gray diamonds are entities you chose when you built or duplicated the graph. They mark where the session began and stay visually distinct from nodes you added later. Visibility filters apply to starting nodes the same as any other node. If you also mark a starting node as a selected node, it appears blue like other selected nodes. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Active edges")]),
            _c("p", [
              _vm._v(
                " Solid lines are links that belong to your working graph: connections returned when you built, loaded, or expanded the graph. They are part of what Save graph to library stores. Some active links skip one or more rows (“jumping” edges); use "
              ),
              _c("em", [_vm._v("Hide jumping edges")]),
              _vm._v(
                " in graph options to keep the view quiet, then hover a node to see jumping links tied to that node. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Contextual edges")]),
            _c("p", [
              _vm._v(
                " Dashed lines are extra associations between nodes already on the canvas, fetched from REVEAL but not added as active graph links. They help you spot plausible connections you might expand into the graph later. By default they stay hidden until you hover a node (or turn off "
              ),
              _c("em", [_vm._v("Hide contextual edges")]),
              _vm._v(
                " to show non-jumping dashed links at once). When contextual edges are hidden, every dashed link stays off—including dashed links that skip a row. When contextual edges are shown, dashed links that skip a row still follow "
              ),
              _c("em", [_vm._v("Hide jumping edges")]),
              _vm._v(". "),
            ]),
          ]),
        ]),
        _c("p", [
          _vm._v(
            " Graph options (eye icon) combine as follows when nothing is hovered: both hides on — only adjacent active (solid) links; hide contextual only — jumping active links plus adjacent active; hide jumping only — adjacent active plus non-jumping dashed contextual; both off — every link. Hover always reveals edges tied to the node under the pointer, even when a hide option is on. "
          ),
        ]),
      ]),
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Inspector drawer")]),
        _c("p", [
          _vm._v(
            " The Inspector sits on the right edge of the canvas and shows element-level evidence—association detail for the node or edge you select—so you can read provenance without losing sight of the graph. Open the Inspector tab, click an element on the canvas, and review what supports that connection while you keep exploring. "
          ),
        ]),
        _c("p", [
          _vm._v(
            " For genes, traits, mechanisms, and gene sets, the Inspector can show top connections, expression profiles, factor loadings, and association-score tables depending on node type. Fetched evidence is cached for the current session; nodes and edges with cached Inspector data show an orange highlight on the graph. "
          ),
        ]),
      ]),
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Analyze features")]),
        _c("ul", { staticClass: "wkb-docs-feature-list" }, [
          _c("li", [
            _c("strong", [_vm._v("Explain graph")]),
            _c("p", [
              _vm._v(" Choose "),
              _c("em", [_vm._v("Selected nodes only")]),
              _vm._v(
                " to focus the narrative on your blue selected nodes, or "
              ),
              _c("em", [_vm._v("All visible nodes")]),
              _vm._v(
                " to summarize everything currently shown on the canvas (respecting visibility filters). Edit the question and optional context before running. Saved explanations appear in the Explanation bubble on the canvas. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Build hypotheses")]),
            _c("p", [
              _vm._v(
                " Requires at least one selected node. REVEAL ranks gene → mechanism → trait pathways that connect your selection, then lets you generate an LLM hypothesis per pathway or open association-score tables. Saved runs appear in the Hypotheses bubble. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Find related datasets")]),
            _c("p", [
              _vm._v(
                " Requires at least one selected gene. Searches CFDE gene sets linked to those genes and shows overlap and enrichment-style scores. Saved runs appear in the Datasets bubble. "
              ),
            ]),
          ]),
        ]),
      ]),
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Analysis bubbles")]),
        _c("p", [
          _vm._v(
            " After you run Explain graph, Build hypotheses, or Find related datasets—from the Analyze menu or the canvas assistant—a numbered bubble appears above the canvas (for example "
          ),
          _c("em", [_vm._v("Explanation 1")]),
          _vm._v(" or "),
          _c("em", [_vm._v("Hypotheses 2")]),
          _vm._v(
            "). Click a bubble to reopen that result while continuing to edit the graph. Bubbles hide while their modal is open and return when you close it. "
          ),
        ]),
      ]),
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Saving and sharing")]),
        _c("ul", { staticClass: "wkb-docs-feature-list" }, [
          _c("li", [
            _c("strong", [_vm._v("My library (quick checkpoint)")]),
            _c("p", [
              _vm._v(
                " Best for resuming on the same browser. Saves nodes, edges, selected nodes, visibility filters, and analysis bubbles—not inspector evidence or expansion history. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Export / Import graph (full workflow)")]),
            _c("p", [
              _vm._v(
                " Best for moving between machines or archiving a session you may reopen in the canvas. Includes inspector caches, expansion history, and candidate caches. Import also accepts a SCOPE CFDE KG handoff file ("
              ),
              _c("code", [_vm._v('kind: "reveal-scope-canvas-handoff"')]),
              _vm._v(
                "): catalog matches become normal nodes; unmatched entities appear as light-gray squares. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [
              _vm._v("Download graph snapshot (read-only review)"),
            ]),
            _c("p", [
              _vm._v(
                " Best for sharing a readable report with collaborators. HTML only—open in a browser; cannot be imported back. "
              ),
            ]),
          ]),
          _c("li", [
            _c("strong", [_vm._v("Back up / Restore library backup")]),
            _c("p", [
              _vm._v(
                " Moves your My library collection between browsers. Same limits as individual library saves—layout only, no inspector data. "
              ),
            ]),
          ]),
        ]),
      ]),
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Reminders")]),
        _c("p", [
          _vm._v(
            " Short callouts below the graph legend suggest next steps after key events—new graph built, expansion finished, analysis completed, or many nodes added since last save. They appear once per graph and dismiss automatically or when you act on them. "
          ),
        ]),
      ]),
      _c("section", { staticClass: "wkb-docs-section" }, [
        _c("h3", [_vm._v("Suggested user flow")]),
        _c("ol", { staticClass: "wkb-docs-flow" }, [
          _c("li", [
            _vm._v(
              "Start with one or two entities (Manage → New graph) or load prior work."
            ),
          ]),
          _c("li", [
            _vm._v(
              "Expand gradually from selected nodes; add specific entities from Graph data."
            ),
          ]),
          _c("li", [
            _vm._v(
              "Narrow the view with visibility filters when the canvas gets busy."
            ),
          ]),
          _c("li", [
            _vm._v("Mark selected nodes and use the Inspector for evidence."),
          ]),
          _c("li", [
            _vm._v(
              " Run Analyze when you are ready to explain, hypothesize, or find datasets—or use the canvas assistant for the same actions in plain language. "
            ),
          ]),
          _c("li", [
            _vm._v(
              "Save to My library for a quick checkpoint; Export graph for a full workflow file; download a snapshot to share a report."
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }